import {AxiosResponse} from 'axios';
import {call, put, select} from 'redux-saga/effects';
import {getBeerPubs} from 'services/beers';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import PubPage from 'typescript/models/PubPage';

import {setBeerPubFiltersAC, setBeerPubsAC, setBeersPageInfoAC} from '../beerSlice';
import {getBeerPubsACS} from '../requestAC';

export function* getBeerPubsSaga(action: ReturnType<typeof getBeerPubsACS>) {
  const {beerPubFilters} = yield select((state) => state.beers);
  try {
    const response: AxiosResponse<ApiData<PubPage[]>> = yield call(getBeerPubs, action.payload);

    yield put(setBeerPubsAC(response.data.data));
    yield put(setBeerPubFiltersAC({...beerPubFilters, totalPages: response.data.meta.total_pages}));
    yield put(
      setBeersPageInfoAC({totalCount: response.data.meta.total_count, totalPages: response.data.meta.total_pages}),
    );
  } catch (error) {
    yield call(handleError, error, 'Could not get list of all pubs of beer.');
  }
}
